






































































































































































































import Vue from "vue"
import { CreateParcelModel } from "@/model/new-parcel-model/create-parcel-model"
import Datatable, { DatatableOptions } from "@/components/datatable/Datatable.vue"
import { ShipmentReceiver } from "@/model/entity/shipment/shipment-receiver"
import { Address } from "@/model/entity/address/address"
import { addressService, IAddressService } from "@/model/service/address/address-service"
import { DpdProduct } from "@/model/new-parcel-model/dpd-product/dpd-product"
import { countryService, ICountryService } from "@/model/service/country/country-service"
import { FieldDescription } from "@/model/entity/field-descriptor"
import { DpdCity } from "@/model/dto/dpd-city"
import { Country } from "@/model/entity/country/country"
import { DpdProductVariant } from "@/model/new-parcel-model/dpd-product/dpd-product-variant"
import { plainToClass } from "class-transformer"

export interface IReceiverGroup extends Vue, IReceiverGroupData {
  getRecipient(): ShipmentReceiver

  setRecipient(receiver: ShipmentReceiver): void

  getAddress(): Address

  clearAll(): void

  isPredictActive: boolean
}

interface IReceiverGroupData {
  addressService: IAddressService
  countryService: ICountryService
  form: any
  rules: any
  options: DatatableOptions
  listAddressesDialog: boolean
  listAddresses: Address[]
  fields: FieldDescription[]
  countryList: SimpleCountry[]
  resetAllFields: number
  postcodepatterns: string
  isZipMandatory: boolean
}

interface SimpleCountry {
  name: string
  code: string
  currency: string
  restricted: boolean
  i18nKey: string
  id: number
}

export default Vue.extend({
  components: {
    Datatable
  },
  data(): IReceiverGroupData {
    return {
      addressService: addressService,
      countryService: countryService,
      isZipMandatory: true,
      form: {
        name: "",
        contact: "",
        zip: "",
        city: "",
        street: "",
        phone: "",
        email: "",
        mobile: "",
        houseNumber: ""
      },
      resetAllFields: 0,
      rules: {
        name: [
          {
            max: 70,
            message: `${this.$t("user_administration.max")} 70 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        contact: [
          {
            max: 35,
            message: `${this.$t("user_administration.max")} 35 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          }
        ],
        city: [
          {
            max: 35,
            message: `${this.$t("user_administration.max")} 35 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        phone: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: string, callback: (err?: Error) => void) => {
              if (value && !new RegExp(/^[(]?[+]?[0-9 \-\/()]+$/).test(value)) {
                callback(new Error(`${this.$t("user_administration.invalid_format.phone")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          }
        ],
        zip: [
          {
            max: 30,
            message: `${this.$t("user_administration.max")} 30 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: any, callback: any) => {
              const vm = this as any
              const isZipMandatory = !vm.postcodepatterns.includes(this.$t("popover.zipcode.empty"))
              if (isZipMandatory) {
                if (value === "") {
                  callback(new Error(`${this.$t("user_administration.field_is_required")}`))
                }
              }
              callback()
            },
            trigger: ["change", "blur"]
          }
        ],
        email: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: string, callback: (err?: Error) => void) => {
              const regexpPattern = /^[\w!#$%&’*+/=?`{|}~^-]+(?:\.[\w!#$%&’*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/
              if (value && !new RegExp(regexpPattern).test(value)) {
                callback(new Error(`${this.$t("user_administration.invalid_format.email")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: any, callback: any) => {
              const isPredictMandatory =
                this.createParcelModel.createParcelModelOptions.predict.value &&
                !this.createParcelModel.createParcelModelOptions.predict.enabled
              const vm = this as any
              if (value === "" && vm.form.mobile === "" && isPredictMandatory && !vm.isDpdHomeSelected) {
                callback(new Error(`${this.$t("user_administration.predict.email_or_mobile")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          }
        ],
        street: [
          {
            max: 60,
            message: `${this.$t("user_administration.max")} 60 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        houseNumber: [
          {
            max: 8,
            message: `${this.$t("user_administration.max")} 8 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        mobile: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: string, callback: (err?: Error) => void) => {
              if (value && !new RegExp(/^[(]?[+]?[0-9 \-\/()]+$/).test(value)) {
                callback(new Error(`${this.$t("user_administration.invalid_format.mobile")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: any, callback: any) => {
              const isPredictMandatory =
                this.createParcelModel.createParcelModelOptions.predict.value &&
                !this.createParcelModel.createParcelModelOptions.predict.enabled
              const vm = this as any
              if (value === "" && vm.form.email === "" && isPredictMandatory && !vm.isDpdHomeSelected) {
                callback(new Error(`${this.$t("user_administration.predict.email_or_mobile")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: any, callback: any) => {
              const vm = this as any
              const isPredictMandatory =
                this.createParcelModel.createParcelModelOptions.predict.value &&
                this.createParcelModel.createParcelModelOptions.predict.enabled
              if (isPredictMandatory && vm.isDpdFood) {
                if (!vm.form.mobile) {
                  callback(new Error(`${this.$t("user_administration.field_is_required")}`))
                }
              }
              callback()
            },
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: any, callback: any) => {
              const vm = this as any
              if (vm.isDpdHomeSelected && !value) {
                callback(new Error(`${this.$t("user_administration.field_is_required")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          }
        ]
      },
      options: {
        dialog: true
      },
      listAddressesDialog: false,
      listAddresses: [],
      fields: Address.getFieldDescriptionList(),
      countryList: [],
      postcodepatterns: ""
    }
  },
  props: {
    createParcelModel: {
      type: CreateParcelModel,
      required: true
    },
    country: {
      type: Object,
      required: true
    },
    receiverValidated: {
      type: Boolean,
      required: true
    },
    hasProductVariant: {
      type: Boolean,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clearAll() {
      this.resetForm()
      this.form = {
        name: "",
        contact: "",
        zip: "",
        city: "",
        street: "",
        phone: "",
        email: "",
        mobile: "",
        houseNumber: ""
      }
      this.$nextTick(() => this.emitValidation())
    },
    fuzzySearchName(input: string, callback: any) {
      if (exists(input) && input.length >= 3) {
        this.addressService.fuzzySearch(input).then(response => {
          callback(response.data)
        })
      } else {
        callback([])
      }
    },
    fuzzySearchZipcode(input: string, callback: any) {
      if (exists(input) && input.length >= 3) {
        this.$http
          .get("cities/fuzzy/zipcodes?country_code=" + this.country.code + "&zipcode=" + input)
          .then(response => {
            callback(response.data)
          })
      } else {
        callback([])
      }
    },
    fuzzySearchCity(input: string, callback: any) {
      if (exists(input) && input.length >= 3) {
        this.$http.get("cities/fuzzy/cities?country_code=" + this.country.code + "&city=" + input).then(response => {
          callback(response.data)
        })
      } else {
        callback([])
      }
    },
    nameKeyupHandler(event: KeyboardEvent) {
      if (event.ctrlKey && event.shiftKey && (event.key === "S" || event.key === "s")) {
        event.stopPropagation()
        this.openDialog()
      }
    },
    showHint() {
      this.$notify.info({
        title: "Tip",
        message: this.$t("new_parcel.hint.receiver.search_tip").toString(),
        duration: 4000
      })
    },
    async changeCountry(country: any) {
      this.$emit("update:country", country)
      await this.$http
        .get(`/product/employee_product_variant/${this.createParcelModel.dpdProduct.type}/${country.id}`)
        .then(res => {
          this.createParcelModel.dpdProductVariants = plainToClass(DpdProductVariant, res.data)
          this.createParcelModel.consolidateVariantFromContext()
        })
      this.$forceUpdate()
    },
    getRecipient(): ShipmentReceiver {
      return new ShipmentReceiver(
        this.form.name,
        this.country.code,
        this.form.zip,
        this.form.city,
        this.form.street,
        this.form.phone,
        this.form.email,
        this.form.mobile,
        this.form.contact,
        this.form.houseNumber
      )
    },
    setCityAndZipcode(entity: DpdCity) {
      this.form.city = entity.name
      this.form.zip = entity.postalCode
    },
    setAddress(entity: Address) {
      this.setComment(entity)

      if (entity !== null) {
        this.form = {
          name: entity.name,
          contact: entity.contact,
          country: entity.country.isoCodeAlpha2,
          zip: entity.zipcode,
          city: entity.city,
          street: entity.street,
          phone: entity.phone,
          email: entity.email,
          mobile: entity.mobile,
          houseNumber: entity.houseNumber
        }
        this.changeCountry({
          name: entity.country.name,
          code: entity.country.isoCodeAlpha2,
          currency: entity.country.currency,
          restricted: entity.country.restricted,
          id: entity.country.id
        })
        this.listAddressesDialog = false
      }
      this.$nextTick(() => this.emitValidation())
    },
    setComment(entity: Address) {
      this.$emit("update:comment", entity.comment)
    },
    getAddress(): Address {
      return new Address(
        this.$store.state.authenticatedEmployee.office,
        this.country.code,
        this.form.name,
        this.form.zip,
        this.form.city,
        this.form.street,
        this.form.houseNumber,
        "",
        this.form.phone,
        this.form.email,
        this.form.mobile,
        this.form.contact
      )
    },

    openDialog() {
      this.listAddressesDialog = true
    },
    emitValidation() {
      const vm = this as any
      vm.$refs.form.validate().catch((e: any) => console.log())
      const fields = vm.$refs.form.fields

      const isFormValid = fields.every(f => {
        const valid = f.validateState === "success"
        const notInErrorState = f.validateState !== "error"
        return valid || notInErrorState
      })

      this.$emit(
        "update:receiverValidated",
        (!this.isPredictActive ||
          (((exists(this.form.email) && this.form.email !== "") ||
            (exists(this.form.mobile) && this.form.mobile !== "")) &&
            this.isPredictActive &&
            this.isCountryAllowed())) &&
          (!this.isDpdHomeSelected || !!this.form.mobile) &&
          isFormValid
      )
    },
    isCountryAllowed() {
      if (
        this.$store.state.authenticatedEmployee.office.company.parcelExportDisabled &&
        this.country.code !== this.$store.getters.domesticCountryIso
      ) {
        return false
      } else {
        return true
      }
    },
    // sets predict if predict isn't mandatory and you input email or mobile
    setPredict() {
      if (this.isDpdFood) {
        const enabled = this.form.mobile.length <= 0
        this.createParcelModel.createParcelModelOptions.predict.enabled = enabled
      } else {
        const value = this.form.email.length > 0 || this.form.mobile.length > 0
        this.createParcelModel.createParcelModelOptions.predict.value = value
      }
    },
    setRecipient(receiver: ShipmentReceiver) {
      this.form.name = receiver.name
      this.form.zip = receiver.postalCode
      this.form.city = receiver.city
      this.form.street = receiver.street1
      this.form.phone = receiver.phone
      this.form.email = receiver.email
      this.form.mobile = receiver.mobile
      this.form.contact = receiver.contact
      this.form.houseNumber = receiver.houseNumber
    },
    // re-renders the form by increasing the key in the form by 1
    resetForm() {
      this.resetAllFields++
      this.$nextTick(() => this.$emit("update:receiverValidated", false))
    },
    async getPostcodepatterns(countryCode: string) {
      return Vue.$http.get("/country/postcodepatterns/" + countryCode)
    },
    async setPostcodepatternsPopoverAndValidateForm() {
      const response = await this.getPostcodepatterns(this.country.code)
      const postcodepatterns = response.data.postcodepatterns

      if (postcodepatterns.includes("")) {
        postcodepatterns[postcodepatterns.indexOf("")] = this.$t("popover.zipcode.empty")
      }
      this.postcodepatterns = postcodepatterns.join("\n")
      this.isZipMandatory = !(
        postcodepatterns.length === 1 && postcodepatterns.includes(this.$t("popover.zipcode.empty"))
      )
      if (!this.isZipMandatory) {
        this.form.zip = ""
      }
      this.emitValidation()
    }
  },
  computed: {
    isDpdFood(): boolean {
      return (
        !!this.createParcelModel.dpdProductVariant &&
        this.createParcelModel.dpdProductVariant.productType.toUpperCase() === "DPD_FRESH"
      )
    },
    isPredictMandatory(): boolean {
      let ret =
        this.createParcelModel.createParcelModelOptions.predict.value &&
        !this.createParcelModel.createParcelModelOptions.predict.enabled

      if (this.isDpdFood) {
        ret =
          this.createParcelModel.createParcelModelOptions.predict.value &&
          this.createParcelModel.createParcelModelOptions.predict.enabled
      }

      return ret
    },
    isEmailMandatory(): boolean {
      return (
        this.createParcelModel.createParcelModelOptions.predict.value &&
        !this.createParcelModel.createParcelModelOptions.predict.enabled
      )
    },
    isDpdHomeSelected(): boolean {
      const dpdProduct = this.createParcelModel.dpdProduct
      return !!dpdProduct && dpdProduct.type === "DPD_HOME"
    },
    isMobileMandatory(): boolean {
      return this.createParcelModel.createParcelModelOptions.predict.value && this.isDpdFood
    },
    isEmailRequired(): boolean {
      return this.isPredictMandatory && this.isEmailMandatory
    },
    isMobileRequired(): boolean {
      return this.isPredictMandatory || this.isMobileMandatory
    },
    isPredictActive(): boolean {
      if (this.readonly) {
        return this.createParcelModel.createParcelModelOptions.predict.value
      }

      return this.isPredictMandatory || this.form.email.length > 0 || this.form.mobile.length > 0
    }
  },
  watch: {
    "createParcelModel.dpdProduct": {
      deep: true,
      handler(newVal: DpdProduct) {
        if (
          newVal.type === "DPD_AIR" &&
          this.$store.state.authenticatedEmployee.office.country.id === this.country.id
        ) {
          this.$emit("update:country", this.countryList[0])
        }
      }
    },
    "createParcelModel.dpdProductVariant": {
      handler() {
        this.setPredict()
        this.emitValidation()
      }
    },
    isDpdHomeSelected: {
      handler() {
        this.emitValidation()
      }
    },
    "country.code": {
      async handler() {
        this.setPostcodepatternsPopoverAndValidateForm()
        this.setPredict()
      }
    },
    "form.name": {
      handler() {
        this.emitValidation()
      }
    },
    "form.contact": {
      handler() {
        this.emitValidation()
      }
    },
    "form.city": {
      handler() {
        this.emitValidation()
      }
    },
    "form.phone": {
      handler() {
        this.emitValidation()
      }
    },
    "form.zip": {
      handler() {
        this.emitValidation()
      }
    },
    "form.email": {
      handler() {
        this.setPredict()
        this.emitValidation()
      }
    },
    "form.street": {
      handler() {
        this.emitValidation()
      }
    },
    "form.mobile": {
      handler() {
        this.setPredict()
        this.emitValidation()
      }
    },
    "form.houseNumber": {
      handler() {
        this.emitValidation()
      }
    },
    "$i18n.locale": {
      handler() {
        this.setPostcodepatternsPopoverAndValidateForm()
      }
    },
    country: {
      async handler() {
        await this.$http
        .get(`/product/employee_product_variant/${this.createParcelModel.dpdProduct.type}/${this.country.id}`)
        .then(res => {
          this.createParcelModel.dpdProductVariants = plainToClass(DpdProductVariant, res.data)
          this.createParcelModel.consolidateVariantFromContext()
        })
        this.$forceUpdate()
      }
    }
  },
  mounted() {
    const autocomplete = this.$refs.firstInput as any
    const firstInput = autocomplete.$children[0].$el.children[0] as any
    firstInput.focus()
    this.emitValidation()
  },
  async created() {
    this.setPostcodepatternsPopoverAndValidateForm()

    const vm = this

    vm.countryService
      .getAll()
      .then(response => {
        vm.countryList = response.data.map(country => {
          return {
            name: country.name,
            code: country.isoCodeAlpha2,
            currency: country.currency,
            restricted: country.restricted || false,
            id: country.id,
            i18nKey: "entity.country." + country.isoCodeAlpha2
          }
        })

        vm.countryList.sort((a, b) => {
          return vm.$t(a.i18nKey) > vm.$t(b.i18nKey) ? 1 : -1
        })
      })
      .catch(error => {
        console.log(error)
      })
  }
})
